import React from "react";

// La ilustración del panel del Dieciocho: la mesa puesta, con banderines
// colgados y tres puestos esperando.
//
// Es literalmente la imagen del texto ("cuando recién están poniendo la mesa")
// y el puesto que espera es el punto de la pieza: dice lo que cuesta trabajar
// el feriado sin dibujar a nadie triste.
//
// Tercera versión. Las dos anteriores quedaron anotadas porque enseñaron algo
// a quien venga a cambiarla: en línea fina y a este tamaño, una empanada sale
// sombrero (media luna) o caja (rectángulo con dobleces), y un pañuelo de
// cueca sale abanico. Los platos, los cubiertos y los banderines sí se
// reconocen. Regla que queda: se dibuja, se RENDERIZA y se mira antes de darla
// por buena; no se da por buena en el papel.
//
// Va en línea para que herede la tinta del tema. Los únicos colores son los de
// la bandera, que son fijos y no los mueve ningún tema. Ni pacientes, ni
// información clínica, ni escenas de sufrimiento.
//
// Quieta: sin animación, nada que apagar bajo prefers-reduced-motion.

// Los banderines cuelgan de una cuerda que se hunde al centro, así que cada
// uno nace un poco más abajo según su posición. El seno da esa caída.
const BANDERINES = [0, 1, 2, 3, 4, 5, 6].map((i) => ({
  i,
  x: 40 + i * 40,
  y: 14 + Math.round(7 * Math.sin((i / 6) * Math.PI)),
  color: ["var(--bandera-azul)", "var(--bandera-blanca)", "var(--bandera-roja)"][i % 3],
}));

const PUESTOS = [78, 160, 242];

export default function MesaDieciocho({ className = "" }) {
  return (
    <svg
      viewBox="0 0 320 132"
      className={`w-full h-auto ${className}`}
      role="img"
      aria-label="Una mesa puesta con banderines colgados y tres puestos esperando"
      focusable="false"
    >
      {/* La cuerda. */}
      <path d="M22 12 C100 30, 220 30, 298 12" fill="none" stroke="var(--ink-faint)" strokeWidth="1.4" />
      {BANDERINES.map(({ i, x, y, color }) => (
        <path
          key={i}
          d={`M${x - 8} ${y} H${x + 8} L${x} ${y + 17} Z`}
          fill={color}
          // El banderín blanco necesita un filo: sin él desaparece sobre el
          // papel claro, igual que en la guirnalda del Home.
          stroke={i % 3 === 1 ? "var(--bandera-azul)" : "none"}
          strokeWidth="0.9"
          strokeOpacity="0.85"
        />
      ))}

      <g fill="none" stroke="var(--ink-subtle)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        {PUESTOS.map((cx) => (
          <g key={cx}>
            <ellipse cx={cx} cy="98" rx="30" ry="9" />
            <ellipse cx={cx} cy="96" rx="16" ry="4.5" strokeWidth="1.2" />
            {/* Un solo cubierto por puesto: con uno a cada lado, los de dos
                puestos vecinos se juntaban y se leían como una doble barra. */}
            <path d={`M${cx - 40} 89 V107`} strokeWidth="1.4" />
          </g>
        ))}
        <path d="M14 118 H306" strokeWidth="2.2" />
      </g>
    </svg>
  );
}
